__turbopack_context__.v({
  "className": "glyphiconfont_103219a0-module__YFrx4q__className",
  "variable": "glyphiconfont_103219a0-module__YFrx4q__variable",
});
